import { render, staticRenderFns } from "./team-case-batch-repayment.vue?vue&type=template&id=253d4b84&scoped=true"
import script from "./team-case-batch-repayment.vue?vue&type=script&lang=ts"
export * from "./team-case-batch-repayment.vue?vue&type=script&lang=ts"
import style0 from "./team-case-batch-repayment.vue?vue&type=style&index=0&id=253d4b84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253d4b84",
  null
  
)

export default component.exports